import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-01n",
  "use": "icon-01n-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-01n\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M55.9382 28.8237C56.9217 27.6659 56.5272 25.8126 55.0389 25.508C53.4113 25.1749 51.7261 25 50 25C36.1929 25 25 36.1929 25 50C25 63.8071 36.1929 75 50 75C55.2133 75 60.054 73.4042 64.0601 70.6745C65.3155 69.8191 64.9663 67.9556 63.6144 67.2628C55.5316 63.1208 50 54.7064 50 45C50 38.831 52.2344 33.1838 55.9382 28.8237Z\" fill=\"#F5C107\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol